import React from "react";
import { Header } from "../../components/feature/Header";
import { Footer } from "../../components/feature/Footer";
import PageHero from "../../components/ui/PageHero";
import heroGalerie from "../../assets/galerie-hero.jpg";
import PhotoGallery from "./components/PhotoGallery";

export default function GaleriePage() {
  return (
    <>
      <Header />
      <PageHero
        src={heroGalerie}
        title="Galerie"
        mode="contain-blur"
        heightClass="h-[44vh] md:h-[56vh]"
        focal="15% 55%"
        alt="CSVBV - Galerie photos"
      />
      <main className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <PhotoGallery />
        </div>
      </main>
      <Footer />
    </>
  );
}
